export const queryKeys = {
    componentGrants: () => ["componentGrants"],
    componentGranters: () => ["componentGranters"],
    componentSubscriptions: () => ["componentSubscriptions"],
    componentSubscribers: () => ["componentSubscribers"],
    extensionBuiltComponents: () => ["extensionBuiltComponents"],
    partnerBuiltComponents: () => ["partnerBuiltComponents"],
    builtComponent: (id) => ["builtComponent", id],
    builtDuplicatableComponents: () => ["builtDuplicatableComponents"],
    campaignSummaries: (queryParams) => ["campaignSummaries", queryParams],
    campaignSummary: (campaignId) => ["campaignSummary", campaignId],
    programs: (queryParams) => ["programs", queryParams],
};
